import { observable } from "mobx";
import { Type } from "class-transformer";
import TransferCounterpartyBankResponse from "./transferCounterpartyBankResponse";
import TransferPaymentType from "./transferPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class RefundTransferPaymentResponse {
  @observable
  transferType?: TransferPaymentType;

  @observable
  @Type(() => TransferCounterpartyBankResponse)
  counterpartyBank?: TransferCounterpartyBankResponse;

  @observable
  counterpartyName?: string;

  @observable
  counterpartyStreetAddress?: string;

  @observable
  counterpartyCityAddress?: string;

  @observable
  counterpartyCountryCode?: string;

  @observable
  additionalAvMessage?: string;

  @observable
  @Type(() => Date)
  postingDate?: Date;
}

export default class RefundTransferPayment extends RefundTransferPaymentResponse {
  @observable
  transferType: TransferPaymentType;

  @observable
  @Type(() => TransferCounterpartyBankResponse)
  counterpartyBank: TransferCounterpartyBankResponse = new TransferCounterpartyBankResponse();
}
